import { useParams } from 'react-router-dom';

import { AdminOrganisationLayout } from './admin-organisation-layout';
import { Permission } from '../../../../../../../backend/src/auth/permissions/permission';
import { OrgPermission } from '../../../../../../../backend/src/organisation/organisation-permission';
import { PricingModel } from '../../../../../../../backend/src/types/types';
import useGetOrganisation from '@/api/queries/useGetOrganisation';
import { usePlatformPermissionCheck } from '@/hooks/usePlatformPermissionCheck';
import { SettingsSectionHeading } from '@/new/components/settings-section';
import { ManagedUsersPanel } from '@/new/pages/manage-users/managed-users-panel';

export function AdminManageUsers() {
  const { organisationId } = useParams();
  if (!organisationId) return null;

  usePlatformPermissionCheck(Permission.PlatformManageUsers);

  const { data: organisation } = useGetOrganisation(organisationId);

  return (
    <AdminOrganisationLayout>
      <SettingsSectionHeading
        title="Users"
        description="View and manage the users in this organisation."
        inset={false}
        className="mb-6 px-8"
      />

      <div className="flex min-h-0 flex-1 flex-col">
        <ManagedUsersPanel
          organisationId={organisationId}
          isSeatBased={organisation?.pricingModel === PricingModel.SeatBased}
          requiresExternalUser2fa={organisation?.permissions.includes(OrgPermission.Require2FANonSSO)}
          showBlockControls
        />
      </div>
    </AdminOrganisationLayout>
  );
}
